import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, map, of } from 'rxjs';
import { ErrorMessage } from '../../shared/models/error-message.enum';
import { PasswordRecoveryService } from '../password-recovery/services/password-recovery.service';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetGuard {
  constructor(
    private passRecoveryService: PasswordRecoveryService,
    private router: Router,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const token = route.paramMap?.get('passwordResetToken');
    const username = route.paramMap?.get('username');
    return this.passRecoveryService.checkResetTokenValid(username, token).pipe(
      map((res: Response) => {
        if (res.status === 200) {
          return true;
        }
        this.router.navigate(['/login']);
        return false;
      }),
      catchError((error) => {
        setTimeout(() => {
          let message = ErrorMessage.TOKEN_INVALID;
          if (error.status === HttpStatusCode.NotFound) {
            message = ErrorMessage.TOKEN_NOT_FOUND;
          } else if (error.status === HttpStatusCode.BadRequest) {
            message = ErrorMessage.TOKEN_BAD_REQUEST;
          }
          this.translateService.get(message).subscribe((res: string) => {
            this.snackBar.open(res, 'Close', {
              duration: 5000,
              panelClass: ['snackbar-error'],
            });
          });
        }, 800);

        this.router.navigate(['/login']);

        return of(false);
      }),
    );
  }
}
